// extracted by css-extract-rspack-plugin
export default {"Trigger":"linked-pr-list-module__Trigger__nCNn4","Number":"linked-pr-list-module__Number__Ulfe8"};